import React, { useEffect, useMemo, useState, useRef } from 'react';
import Api from '../../Services/Api.service'
import Header from './Header.component';
import CssBaseline from '@material-ui/core/CssBaseline';
import MmsService from 'Services/MMS/mms-api.service';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import { useAuth } from 'Contexts/AuthProvider';
import { List, ListItem, ListItemText, MenuItem, Popover, TextField, Tooltip } from '@material-ui/core';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import AlertToastr from 'utils/alert';
import SaveDepartmentModal from '../../Pages/PredictiveMaintenance/Companies/Modals/SaveDepartmentModal';
import SaveEmployeeModal from '../../Pages/PredictiveMaintenance/Companies/Modals/SaveEmployeeModal';
import SaveComponentModal from '../../Pages/PredictiveMaintenance/Equipment/Modals/SaveComponentModal';
import SavePartModal from '../../Pages/PredictiveMaintenance/Equipment/Modals/SavePartModal';
import ChangeDepartmentModal from '../../Pages/PredictiveMaintenance/Equipment/Modals/ChangeDepartmentModal';
import DeleteItemModal from 'Components/modals/delete-item-modal/delete-item-modal.component';
// import DuplicateComponentModal from '../../Pages/PredictiveMaintenance/Equipment/Modals/DuplicateComponentModal';
import CloneToEquipmentModal from '../../Pages/PredictiveMaintenance/Catalog/Modals/CloneToEquipmentModal';
import SaveScheduledReportsModal
    from '../../Pages/PredictiveMaintenance/ScheduledReports/Modals/SaveScheduledReportsModal';
import SaveCompanyModal from '../../Pages/PredictiveMaintenance/Companies/Modals/SaveCompanyModal';
import {
    setComponents,
    setCurrentDepartment,
    setDepartments,
    setEditingCompany,
    setEmployees,
    setParts,
    setReports,
    setUnassignedComponents,
    setRunComponentsUpdate,
    setStatusOptions,
    setStates,
    setTypeOptions,
} from 'Store/modules/mms/actions';
import ThemeSelector from '../ThemeSelector/ThemeSelector.component';
import LanguageSelector from '../LanguageSelector/LanguageSelector.component';
import ExportReportModal from 'Pages/PredictiveMaintenance/ScheduledReports/Modals/ExportReportModal';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/MoreVert';
import useTranslation from 'Hooks/useTranslation';
import { apiMmsBaseUrl, appName } from '../../config';
import { useQuery, useQueryClient } from 'react-query';
import axios from 'axios';
import { useAppSettings } from '../../Contexts/AppSettingsProvider';
import { clearStoredDepartment, getStoredDepartment, setStoredDepartment } from '../../storage/department-storage';
import EventEmitter from '../../utils/EventEmitter';
import { useComponents } from '../../Hooks/mms/useComponents';
import DmsService from 'Services/DMS/dms-api.service';
import MyIcons from 'assets/img/Icons/MyIcons';
import Fade from '@material-ui/core/Fade';
import CircularProgress from '@material-ui/core/CircularProgress'
import ExportConfirmationModal from 'Components/modals/ExportConfirmationModal';
import printJS from 'print-js';
import CreateEditAssetTypeModal from 'Components/modals/AssetTypeModal/create-edit-asset-type-modal';
import AddEditMetricModal from 'Components/modals/AddEditMetricModal/create-edit-metric-modal';






const PredMainLayout = (
    {
        children,
        departments,
        currentDepartment,
        setCurrentDepartment,
        currentCompany,
        setDepartments,
        currentPage,
        components,
        setParts,
        parts,
        componentsCatalog,
        setComponents,
        setUnassignedComponents,
        partsCatalog,
        setRunComponentsUpdate,
        setTypeOptions,
        setStatusOptions,
        setStates,
        setEmployees,
        reports,
        setReports,
        filterInfo,
        activities,
        pageTitle,
        rspSelectedComponentsIds,
        selectedUnassignedComponentsIds,
        editingCompany,
        setEditingCompany,
    }) => {

    const { currentUser, userLoaded } = useAuth();
    const isSuperUser = useMemo(() => (currentUser.isSuperuser()), [currentUser]);
    const [isOpenSaveDepartmentModal, setIsOpenSaveDepartmentModal] = useState(false);
    const [isOpenSaveCompanyModal, setIsOpenSaveCompanyModal] = useState(false);
    const [isOpenSaveEmployeeModal, setIsOpenSaveEmployeeModal] = useState(false);
    const [isOpenSaveComponentModal, setIsOpenSaveComponentModal] = useState(false);
    const [isOpenCloneToEquipmentModal, setIsOpenCloneToEquipmentModal] = useState(false);
    const [isOpenChangeDepartmentModal, setIsOpenChangeDepartmentModal] = useState(false);
    const [isOpenDeleteComponentsModal, setIsOpenDeleteComponentsModal] = useState(false);
    // const [isOpenDuplicateComponentModal, setIsOpenDuplicateComponentModal] = useState(false);
    const [isOpenSaveScheduleModal, setIsOpenSaveScheduleModal] = useState(false);
    const [isOpenDeletePartsModal, setIsOpenDeletePartsModal] = useState(false);
    const [isOpenDeleteReportsModal, setIsOpenDeleteReportsModal] = useState(false);
    const [isOpenDeleteUCModal, setIsOpenDeleteUCModal] = useState(false);
    const [isOpenExportReportModal, setIsOpenExportReportModal] = useState(false);
    const [isOpenSavePartModal, setIsOpenSavePartModal] = useState(false);
    const [disableExportButton, setDisableExportButton] = useState(false);
    const [isCatalog, setIsCatalog] = useState(false);
    const [cloneInstance, setCloneInstance] = useState('components');
    const { dashboardId } = useParams();
    const location = useLocation();
    const translation = useTranslation();
    const queryClient = useQueryClient();
    const [departmentSearchQuery, setDepartmentSearchQuery] = useState('');
    const [departmentSelectAnchor, setDepartmentSelectAnchor] = useState(null);
    const history = useHistory();
    
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location.pathname]);

    const {
        showActivitiesPartsExportPdf,
        appLanguage,
    } = useAppSettings();
    const [, setAllowRemoveNotifications] = useState(false);
    const [isLoading, setIsLoading] = useState(false)
    const [activitiesPDFisLoading, setActivitiesPDFIsLoading] = useState(false)
    const [componentsCSVisLoading, setComponentsCSVisLoading] = useState(false)
    const [activitiesPartsPDFisLoading, setActivitiesPartsPDFIsLoading] = useState(false)
    const [activitiesFilesIsLoading, setActivitiesFilesIsLoading] = useState(false)

    const [isExportConfirmationOpen, setIsExportConfirmationOpen] = useState(false);
    const [isOpenCreateEditAssetTypeModal, setIsOpenCreateEditAssetTypeModal] = useState(false);
    const [isOpenCreateEditMetricModal, setIsOpenCreateEditMetricModal] = useState(false);

    const handleConfirmExport = () => {
        setIsExportConfirmationOpen(false);
        exportReport();
    };

    const tryExportReport = () => {
        const selectedCount = activities.filter(a => a.selected).length;
        const exportCount = selectedCount > 0 ? selectedCount : activities.length;

        if (exportCount > 20) {
            setIsExportConfirmationOpen(true);
        } else {
            setIsExportConfirmationOpen(false);
            exportReport();
        }
    };    

    const handleShowFilter = () => {
        setIsExportConfirmationOpen(false);
        EventEmitter.emit('openFilter');
    };

    const [anchorCompanyMenuEl, setAnchorCompanyMenuEl] = useState(null);
    const handleCompanyMenuOpen = (event) => {
        event.stopPropagation();
        setAnchorCompanyMenuEl(event.currentTarget);
    };
    const handleCompanyMenuClose = () => setAnchorCompanyMenuEl(null);
    // const { path, url } = useRouteMatch();
    const inputFile = useRef(null);
    const inputCompanyLogoRef = useRef(null);

    useEffect(() => {
        const onEvent = (selected) => setAllowRemoveNotifications(selected);

        const listener = EventEmitter.addListener('NotificationsSelected', onEvent);
        return () => {
            listener.remove();
        };
    }, []);

    useEffect(() => {
        const onOpenSaveCompanyModal = () => setIsOpenSaveCompanyModal(true);
        const onChangeCompanyLogo = () => inputCompanyLogoRef.current?.click();
        const listeners = [
            EventEmitter.addListener('OpenSaveCompanyModal', onOpenSaveCompanyModal),
            EventEmitter.addListener('ChangeCompanyLogo', onChangeCompanyLogo),
        ];
        return () => listeners.forEach((l) => l.remove());
    }, []);

    const departmentsRequest = useQuery(
        ['departments', currentCompany],
        async () => {
            const config = !currentUser.isSuperuser() ? {} : {
                headers: { 'CompanyId': currentCompany?.id },
            };
            return await axios.get(`${apiMmsBaseUrl}/departments`, config);
        },
        { keepPreviousData: true, enabled: userLoaded },
    );

    useEffect(() => {
        if (departmentsRequest.isSuccess) {
            const { data, status } = departmentsRequest.data;
            setDepartments(status === 200 ? data : []);
        }
    }, [departmentsRequest.isSuccess, departmentsRequest.data, setDepartments]);


    const employeesRequest = useQuery(
        ['employees', currentCompany],
        async () => {
            const config = !currentUser.isSuperuser() ? {} : {
                headers: { 'CompanyId': currentCompany?.id },
            };
            return await axios.get(`${apiMmsBaseUrl}/employees`, config);
        },
        { keepPreviousData: true, enabled: userLoaded },
    );

    useEffect(() => {
        if (employeesRequest.isSuccess) {
            const { data, status } = employeesRequest.data;
            setEmployees(status === 200 ? data : []);
        }
    }, [employeesRequest.isSuccess, employeesRequest.data, setEmployees]);


    const componentsRequest = useComponents(currentDepartment?.id);

    useEffect(() => {
        if (componentsRequest.isSuccess && componentsRequest.data) {
            setComponents(componentsRequest.data.data);
        }
    }, [componentsRequest.isSuccess, componentsRequest.data, setComponents]);

    // useEffect(() => {
    //     async function fetchUnassignedComponents() {
    //       if (currentCompany?.id) {
    //         const unassignedComponentsRequest = await Api.get(
    //           `${apiMmsBaseUrl}/components/unassigned`,
    //           {
    //             headers: isSuperUser ? { 'CompanyId': currentCompany.id } : {},
    //           }
    //         );
      
    //         if (unassignedComponentsRequest.data) {
    //           setUnassignedComponents(unassignedComponentsRequest.data.data);
    //         }
    //       }
    //     }
      
    //     fetchUnassignedComponents();
    //   }, [currentCompany?.id, isSuperUser, setUnassignedComponents]);
      


    useEffect(() => {
        const fetchParts = async () => {
            try {
                const response = await MmsService.getPartsList();
                setParts(response?.data);
            } catch (error) {
                if (error && error.response && error.response.data && error.response.data.message)
                    AlertToastr.showErrorAlert(error.response.data.message);
            }
        };
        // const fetchComponents = async () => {
        //     try {
        //         const response = await MmsService.getComponents(currentDepartment.id);
        //         setComponents(response.data);
        //     } catch (error) {
        //         if (error && error.response && error.response.data && error.response.data.message)
        //             AlertToastr.showErrorAlert(error.response.data.message);
        //     }
        // };
        if (!currentDepartment)
            return;
        fetchParts();
        // fetchComponents();
    }, [currentDepartment, setComponents, setParts]);

    useEffect(() => {
        const fetchTypeOptions = async (lang) => {
            let response = await MmsService.getTypesOptions(lang);
            setTypeOptions(response?.data);
        };
        const fetchStatusOptions = async (lang) => {
            let response = await MmsService.getStatusOptions(lang);
            setStatusOptions(response.data);
        };
        const fetchStates = async (lang) => {
            let response = await MmsService.getStates(lang);
            setStates(response.data);
        };
        fetchTypeOptions(appLanguage);
        fetchStatusOptions(appLanguage);
        fetchStates(appLanguage);
    }, [setStatusOptions, setStates, setTypeOptions, appLanguage]);

    useEffect(() => {
        if (!departments) return;

        // const isAssetPage = location.pathname === '/asset-types' || location.pathname === '/asset-metrics';
        
        // if (departments.length === 0 && !isAssetPage) {
        //     history.push(`/companies`);
        //     setCurrentDepartment(null);
        //     clearStoredDepartment();
        //     return;
        // }

        // if (departments.length === 0 && isAssetPage) {
        //     setCurrentDepartment(null);
        //     return;
        // }

        const storedDepartmentId = getStoredDepartment();
        const storedDepartmentModel = departments.find(d => d.id === storedDepartmentId);

        let defaultDepartment;

        if (storedDepartmentModel) {
            defaultDepartment = storedDepartmentModel;
        } else {
            defaultDepartment = departments[0];
            setStoredDepartment(defaultDepartment?.id);
        }

        setCurrentDepartment(defaultDepartment);

    }, [
        departments, setCurrentDepartment, history, location.pathname,
    ]);

    const filteredDepartments = useMemo(() => {
        if (!departments || !departmentSearchQuery) return departments;
        const q = departmentSearchQuery.toLowerCase();
        return departments.filter((d) => d.name?.toLowerCase().includes(q));
    }, [departments, departmentSearchQuery]);

    const selectedComponentsIds = useMemo(() => rspSelectedComponentsIds, [rspSelectedComponentsIds]);
    const selectedUCIds = useMemo(() => selectedUnassignedComponentsIds, [selectedUnassignedComponentsIds]);

    const selectedPartsIds = useMemo(() => {
        if (!parts) return [];
        return parts.filter(c => c.selected).map(c => c.id);
    }, [parts]);

    const selectedComponentsCatalogIds = useMemo(() => {
        if (!componentsCatalog) return [];
        return componentsCatalog.filter(c => c.selected).map(c => c.id);
    }, [componentsCatalog]);

    const selectedPartsCatalogIds = useMemo(() => {
        if (!partsCatalog) return [];
        return partsCatalog.filter(c => c.selected).map(c => c.id);
    }, [partsCatalog]);

    const selectedReportsIds = useMemo(() => {
        if (!reports) return [];
        return reports.filter(c => c.selected).map(c => c.id);
    }, [reports]);

    const onDeleteComponents = () => {
        setIsLoading(true); 
        const selectedComponents = isCatalog ? selectedComponentsCatalogIds : selectedComponentsIds;
        MmsService.deleteComponents(selectedComponents)
            .then(res => {
                if (res.data.isSuccessful) {
                    AlertToastr.showAlert(res.data.message)
                    queryClient.invalidateQueries(['components']);
                    // AlertToastr.showAlert(selectedComponents.length === 1 ? translation.notificationsComponentDeleted : translation.notificationsComponentsDeleted);
                    setRunComponentsUpdate(Math.random());
                }
            })
            .catch((error) => {
                if (error && error.response && error.response.data && error.response.data.message)
                    AlertToastr.showErrorAlert(error.response.data.message);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const onDeleteUnassignedComponents = () => {
        const selectedComponents = isCatalog ? selectedComponentsCatalogIds : selectedUCIds;
        MmsService.deleteUnassignedComponents(selectedComponents).then(res => {
            if (res.data.isSuccessful) {
                AlertToastr.showAlert(res.data.message)
                queryClient.invalidateQueries(['unassigned']);
                // AlertToastr.showAlert(selectedComponents.length === 1 ? translation.notificationsComponentDeleted : translation.notificationsComponentsDeleted);
                setRunComponentsUpdate(Math.random());
            }
        })
            .catch((error) => {
                if (error && error.response && error.response.data && error.response.data.message)
                    AlertToastr.showErrorAlert(error.response.data.message);
            });
    };

    const exportRsp = () => {
        setDisableExportButton(true);
        MmsService.exportRsp(currentDepartment.id, rspSelectedComponentsIds).then(res => {
            setDisableExportButton(false);
            const file = new Blob(
                [res.data],
                { type: 'application/pdf' });
            const fileURL = URL.createObjectURL(file);
            window.open(fileURL);
        })
            .catch((error) => {
                setDisableExportButton(false);
                if (error && error.response && error.response.data && error.response.data.message)
                    AlertToastr.showErrorAlert(error.response.data.message);
            });
    };

    const onDeleteParts = () => {
        const partsIds = isCatalog ? selectedPartsCatalogIds : selectedPartsIds;
        MmsService.deleteParts(partsIds).then(res => {
            if (res.data.isSuccessful) {
                AlertToastr.showAlert(partsIds.length === 1 ? translation.notificationsPartDeleted : translation.notificationsPartsDeleted);
                const newParts = parts.filter(d => !selectedPartsIds.includes(d.id));
                setParts(newParts);
            }
        })
            .catch((error) => {
                if (error && error.response && error.response.data && error.response.data.message)
                    AlertToastr.showErrorAlert(error.response.data.message);
            });
    };

    const onDeleteReports = () => {
        MmsService.deleteReports(selectedReportsIds).then(res => {
            if (res.data.isSuccessful) {
                AlertToastr.showAlert(selectedReportsIds.length === 1 ? translation.notificationsReportDeleted : translation.notificationsReportsDeleted);
                const newReports = reports.filter(d => !selectedReportsIds.includes(d.id));
                setReports(newReports);
            }
        })
            .catch((error) => {
                if (error && error.response && error.response.data && error.response.data.message)
                    AlertToastr.showErrorAlert(error.response.data.message);
            });
    };


    
    const exportReport = async () => {
        setActivitiesPDFIsLoading(true);
        const selectedActivities = activities.filter(a => a.selected);
        const filters = selectedActivities.length
            ? {
                ...filterInfo,
                activityIds: selectedActivities.map(a => a.id),
            }
            : {
                ...filterInfo,
            };
        
        try {
            const res = await MmsService.exportReport(currentDepartment.id, filters);
            let htmlString = await res.data.text();
          
            const styleRegex = /<style[^>]*>[\s\S]*?<\/style>/g;
            const styles = htmlString.match(styleRegex);
            if (styles) {
                htmlString = htmlString.replace(styleRegex, '');
                htmlString = styles[0] + htmlString;
            }
          
            const pageContainer = document.createElement('div');
            pageContainer.innerHTML = htmlString;
            document.body.appendChild(pageContainer);
           
            printJS({
                printable: pageContainer.innerHTML,
                type: 'raw-html',
                style: styles ? styles[0] : '',
                onLoadingStart: () => {},
                onLoadingEnd: () => {
                    document.body.removeChild(pageContainer);
                    setActivitiesPDFIsLoading(false);
                },
                pdfCallback: (pdf) => {
                    window.open(pdf);
                },
            });
        } catch (error) {
            console.error("Error generating PDF:", error);
            setActivitiesPDFIsLoading(false);
        }
    };

    
    

    const exportActivitiesPartReport = () => {
        const exportActivitiesIds = activities.filter(item => item.selected).map(item => item.id);
        setActivitiesPartsPDFIsLoading(true)

        MmsService.exportActivityParts(currentDepartment.id, exportActivitiesIds)
            .then(res => {
                const file = new Blob(
                    [res.data],
                    { type: 'application/pdf' });
                const fileURL = URL.createObjectURL(file);
                window.open(fileURL);
                if(res) {
                    setActivitiesPartsPDFIsLoading(false)
                }
            })
            .catch((error) => {
                if (error && error.response && error.response.data && error.response.data.message)
                    AlertToastr.showErrorAlert(error.response.data.message);
                    setActivitiesPartsPDFIsLoading(false)
            });
    };

    const getFileNameFromContentDisposition = (contentDisposition) => {
        if (!contentDisposition) return 'activity-files.zip';
        const encodedMatch = contentDisposition.match(/filename\*=(?:UTF-8'')?([^;]+)/i);
        if (encodedMatch) return decodeURIComponent(encodedMatch[1].replace(/"/g, '').trim());
        const match = contentDisposition.match(/filename=([^;]+)/i);
        return match ? match[1].replace(/"/g, '').trim() : 'activity-files.zip';
    };

    const activityHasFiles = (activity) => !!(activity?.fileIds?.length || activity?.files?.length);

    const hasSelectedActivitiesFiles = useMemo(
        () => !!activities && activities.some(a => a.selected && activityHasFiles(a)),
        [activities]
    );

    const exportActivitiesFiles = async () => {
        const exportActivitiesIds = activities.filter(item => item.selected && activityHasFiles(item)).map(item => item.id);
        if (!exportActivitiesIds.length) return;
        setActivitiesFilesIsLoading(true);

        try {
            const res = await MmsService.exportActivityFiles(exportActivitiesIds);
            const fileName = getFileNameFromContentDisposition(res.headers['content-disposition']);
            const url = window.URL.createObjectURL(new Blob([res.data], { type: res.headers['content-type'] }));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            if (error?.response?.status === 404) {
                AlertToastr.showErrorAlert(translation.notificationsNoActivityFilesFound);
            } else {
                // blob responseType: error body comes back as a Blob, parse it for the message
                let message = null;
                try {
                    const text = await error?.response?.data?.text();
                    message = JSON.parse(text)?.message;
                } catch (e) {}
                if (message) AlertToastr.showErrorAlert(message);
            }
        } finally {
            setActivitiesFilesIsLoading(false);
        }
    };

    const [anchorElAsidePopover, setAnchorElAsidePopover] = React.useState(null);

    const handleClickAsidePopover = (event) => {
        setAnchorElAsidePopover(event.currentTarget);
    };

    const handleCloseAsidePopover = () => {
        setAnchorElAsidePopover(null);
    };

    const onFileSelected = (file) => {
        DmsService.uploadCompanyImage(editingCompany.id, file).then(async (response) => {
            if (response.data.isSuccessful) {
                let response = await DmsService.getCompanyImage(editingCompany.id);
                setEditingCompany(response.data);
            }
        }).catch(error => {
            if (error && error.response && error.response.data && error.response.data.message)
                AlertToastr.showErrorAlert(error.response.data.message);
        });
    };

    const handleExportToCSV = async () => {
        if (!currentDepartment?.id) return;
    
        setComponentsCSVisLoading(true);
        try {
            let idsToExport = selectedComponentsIds;
            if (selectedComponentsIds.length === 0) {
                idsToExport = components
                    .filter(component => !component.parentComponentId)
                    .map(component => component.id);
            }
    
            const response = await MmsService.exportComponentsToCsv(currentDepartment.id, idsToExport);
            
            const contentDisposition = response.headers['content-disposition'];
            let filename = 'components_export.csv'; 
            if (contentDisposition) {
                const match = contentDisposition.match(/filename="([^"]+)"/);
                if (match && match[1]) {
                    filename = match[1]; 
                }
            }
    
            const file = new Blob([response.data], { type: 'text/csv' });
            const fileURL = URL.createObjectURL(file);
            const link = document.createElement('a');
            link.href = fileURL;
            link.download = filename;
            link.click();
            URL.revokeObjectURL(fileURL);
        } catch (error) {
            console.error('Error exporting to CSV:', error);
            AlertToastr.showErrorAlert('Failed to export components to CSV');
        } finally {
            setComponentsCSVisLoading(false);
        }
    };

    useEffect(() => {
        const fetchCompanyImage = async (id) => {
            let response = await DmsService.getCompanyImage(id);
            setEditingCompany(response.data);
        };
        if (currentCompany)
            fetchCompanyImage(currentCompany.id).then();
        if (currentUser && currentUser.companyId)
            fetchCompanyImage(currentUser.companyId).then();
    }, [currentCompany, currentUser, setEditingCompany]);

    const renderContextMenu = () => {
        if (location.pathname === '/dashboard') return null;
        return (
            <div className="asideNavHolder secondary">
                {location.pathname === '/companies' && <ul className="asideNav">
                    <li className="asideNavItemHolder">
                        <Button
                            fullWidth
                            startIcon={<MyIcons icon='createIcon'/>}
                            className="asideNavItem"
                            onClick={(e) => setIsOpenSaveCompanyModal(true)}
                            id='myCompanyEditBtn'
                        >
                            {translation.sideMenuEditCompanyLabel}
                        </Button>
                    </li>
                    <li className="asideNavItemHolder">
                        <Button
                            fullWidth
                            startIcon={<MyIcons icon='photoCamera'/>}
                            className="asideNavItem"
                            onClick={e => inputFile.current.click()}
                            id='myCompanyChangeLogoBtn'
                        >
                            {translation.sideMenuEditLogoLabel}
                        </Button>
                        <input type="file" id="file"
                                   ref={inputFile} style={{ display: 'none' }}
                                   onChange={(e) => {
                                       if (!e.target.files[0])
                                           return;
                                       onFileSelected(e.target.files[0]);
                                   }} />
                    </li>

                </ul>}
                {location.pathname === '/equipment' && currentPage === 'equipment' && <ul className="asideNav">
                    <li className="asideNavItemHolder">
                        <Button
                            fullWidth
                            startIcon={<MyIcons icon='addCircleOutlineIcon'/>}
                            className="asideNavItem"
                            id="assetsAddBtn"
                            onClick={(e) => EventEmitter.emit('CreateNewComponent')}
                        >
                            {translation.sideMenuAddNewComponentLabel}
                        </Button>
                    </li>
                    {/*<li className="asideNavItemHolder">*/}
                    {/*    <Button*/}
                    {/*        disabled={!selectedComponentsIds.length}*/}
                    {/*        fullWidth*/}
                    {/*        startIcon={<MyIcons icon='filterNoneIcon'/>}*/}
                    {/*        className="asideNavItem"*/}
                    {/*        onClick={(e) => {*/}
                    {/*            setIsCatalog(false);*/}
                    {/*            setIsOpenDuplicateComponentModal(true);*/}
                    {/*        }}*/}
                    {/*    >*/}
                    {/*        {translation.sideMenuDuplicateLabel}*/}
                    {/*    </Button>*/}
                    {/*</li>*/}
                    <li className="asideNavItemHolder">
                        <Button
                            disabled={!selectedComponentsIds.length}
                            fullWidth
                            startIcon={<MyIcons icon='deleteOutlineIcon'/>}
                            className="asideNavItem"
                            id="assetsRemoveBtn"
                            onClick={(e) => {
                                setIsCatalog(false);
                                setIsOpenDeleteComponentsModal(true);
                            }}
                        >
                            {translation.sideMenuRemoveLabel}
                        </Button>
                    </li>
                    <li className="asideNavItemHolder">
                        <Button
                            disabled={!selectedComponentsIds.length}
                            fullWidth
                            startIcon={<MyIcons icon='lowPriorityIcon'/>}
                            className="asideNavItem"
                            id="assetsChangeDepBtn"
                            onClick={(e) => setIsOpenChangeDepartmentModal(true)}
                        >
                            {translation.sideMenuChangeDepartmentLabel}
                        </Button>
                    </li>
                </ul>}
                {location.pathname === '/equipment' && <ul className="asideNav">
                    <li className="asideNavItemHolder">
                        <Button
                            disabled={disableExportButton || !rspSelectedComponentsIds.length}
                            fullWidth
                            startIcon={<MyIcons icon='getAppIcon'/>}
                            className="asideNavItem"
                            onClick={(e) => exportRsp()}
                            id="assetsExportPDFBtn"
                        >
                            {/*{translation.sideMenuPrintLabel}*/}
                            {translation.sideMenuExportSparePartsLabel}
                            <div className="loaderHolder">
                              <Fade in={disableExportButton} unmountOnExit style={{position: 'absolute', top: '25%', right: '10%', zIndex: '100', width: '20px', height: '20px'}}>  
                                <CircularProgress />
                              </Fade>
                            </div>
                        </Button>
                    </li>
                    <li className="asideNavItemHolder">
                            <Button
                                // disabled={!selectedComponentsIds.length}
                                fullWidth
                                startIcon={<MyIcons icon='getAppIcon'/>}
                                className="asideNavItem"
                                id="componentsExportCSVBtn"
                                onClick={handleExportToCSV}
                            >
                                Export Unit Hours CSV
                                <div className="loaderHolder">
                                  <Fade in={componentsCSVisLoading} unmountOnExit style={{position: 'absolute', top: '25%', right: '40%', zIndex: '100', width: '20px', height: '20px'}}>  
                                    <CircularProgress />
                                  </Fade>
                                </div>
                            </Button>
                    </li>
                </ul>}
                {location.pathname === '/parts' && <ul className="asideNav">
                    <li className="asideNavItemHolder">
                        <Button
                            fullWidth
                            startIcon={<MyIcons icon='addCircleOutlineIcon'/>}
                            className="asideNavItem"
                            onClick={(e) => {
                                setIsCatalog(false);
                                setIsOpenSavePartModal(true);
                            }}
                            id="partsAddBtn"
                        >
                            {translation.sideMenuAddNewPartLabel}
                        </Button>
                    </li>
                    <li className="asideNavItemHolder">
                        <Button
                            disabled={!selectedPartsIds.length}
                            fullWidth
                            startIcon={<MyIcons icon='deleteOutlineIcon'/>}
                            className="asideNavItem"
                            onClick={(e) => setIsOpenDeletePartsModal(true)}
                            id="partsRemoveBtn"
                        >
                            {translation.sideMenuRemoveLabel}
                        </Button>
                    </li>
                </ul>}
                {location.pathname === '/catalog' && currentPage === 'components' && <ul className="asideNav">
                    {isSuperUser &&
                        <li className="asideNavItemHolder">
                            <Button
                                fullWidth
                                startIcon={<MyIcons icon='addCircleOutlineIcon'/>}
                                className="asideNavItem"
                                onClick={(e) => {
                                    setIsCatalog(true);
                                    setIsOpenSaveComponentModal(true);
                                }}
                            >
                                {translation.sideMenuAddNewComponentLabel}
                            </Button>
                        </li>}
                    {isSuperUser &&
                        <>
                            {/* <li className="asideNavItemHolder">
                                <Button
                                    disabled={!selectedComponentsCatalogIds.length}
                                    fullWidth
                                    startIcon={<MyIcons icon='filterNoneIcon'/>}
                                    className="asideNavItem"
                                    onClick={(e) => {
                                        setIsCatalog(true);
                                        setIsOpenDuplicateComponentModal(true);
                                    }}
                                >
                                    {translation.sideMenuDuplicateLabel}
                                </Button>
                            </li> */}
                            <li className="asideNavItemHolder">
                                <Button
                                    disabled={!selectedComponentsCatalogIds.length}
                                    fullWidth
                                    startIcon={<MyIcons icon='deleteOutlineIcon'/>}
                                    className="asideNavItem"
                                    onClick={(e) => {
                                        setIsCatalog(true);
                                        setIsOpenDeleteComponentsModal(true);
                                    }}
                                >
                                    {translation.sideMenuRemoveLabel}
                                </Button>
                            </li>
                        </>}
                    {!isSuperUser && <li className="asideNavItemHolder">
                        <Button
                            disabled={!selectedComponentsCatalogIds.length}
                            fullWidth
                            startIcon={<MyIcons icon='lowPriorityIcon'/>}
                            className="asideNavItem"
                            onClick={(e) => {
                                setCloneInstance('components');
                                setIsOpenCloneToEquipmentModal(true);
                            }}
                        >
                            {translation.sideMenuTakeToMyEquipmentLabel}
                        </Button>
                    </li>}
                </ul>}
                {location.pathname === '/catalog' && currentPage === 'parts' && <ul className="asideNav">
                    {isSuperUser &&
                        <li className="asideNavItemHolder">
                            <Button
                                fullWidth
                                startIcon={<MyIcons icon='addCircleOutlineIcon'/>}
                                className="asideNavItem"
                                onClick={(e) => {
                                    setIsCatalog(true);
                                    setIsOpenSavePartModal(true);
                                }}
                            >
                                {translation.sideMenuAddNewPartLabel}
                            </Button>
                        </li>}
                    {isSuperUser &&
                        <li className="asideNavItemHolder">
                            <Button
                                disabled={!selectedPartsCatalogIds.length}
                                fullWidth
                                startIcon={<MyIcons icon='deleteOutlineIcon'/>}
                                className="asideNavItem"
                                onClick={(e) => setIsOpenDeletePartsModal(true)}
                            >
                                {translation.sideMenuRemoveLabel}
                            </Button>
                        </li>}
                    {!isSuperUser && <li className="asideNavItemHolder">
                        <Button
                            disabled={!selectedPartsCatalogIds.length}
                            fullWidth
                            startIcon={<MyIcons icon='lowPriorityIcon'/>}
                            className="asideNavItem"
                            onClick={(e) => {
                                setCloneInstance('parts');
                                setIsOpenCloneToEquipmentModal(true);
                            }}
                        >
                            {translation.sideMenuTakeToMyEquipmentLabel}
                        </Button>
                    </li>}
                </ul>}
                {location.pathname === '/activities' &&
                    <ul className="asideNav">
                        <li className="asideNavItemHolder">
                            <Button
                                fullWidth
                                startIcon={<MyIcons icon='equalizerIcon'/>}
                                className="asideNavItem"
                                id="activitiesAddScheduledReportBtn"
                                onClick={(e) => {
                                    setIsOpenSaveScheduleModal(true);
                                }}
                            >
                                {translation.sideMenuScheduledReportsLabel}
                            </Button>
                        </li>
                        <li className="asideNavItemHolder">
                            <Button
                                disabled={!activities || activities.length === 0 || activitiesPDFisLoading}
                                fullWidth
                                startIcon={<MyIcons icon='getAppIcon'/>}
                                className="asideNavItem"
                                id="activitiesExportPDFBtn"
                                onClick={tryExportReport}
                            >
                                {translation.sideMenuExportReportsLabel}
                                <div className="loaderHolder">
                                  <Fade in={activitiesPDFisLoading} unmountOnExit style={{position: 'absolute', top: '25%', right: '40%', zIndex: '100', width: '20px', height: '20px'}}>  
                                    <CircularProgress />
                                  </Fade>
                                </div>
                            </Button>
                        </li>
                        <li className="asideNavItemHolder">
                            <Button
                                disabled={!showActivitiesPartsExportPdf}
                                fullWidth
                                startIcon={<MyIcons icon='getAppIcon'/>}
                                className="asideNavItem"
                                id="activitiesPartsExportPDFBtn"
                                onClick={exportActivitiesPartReport}
                            >
                                {translation.sideMenuExportActivitiesPartsToPdfLabel}
                                <div className="loaderHolder">
                                  <Fade in={activitiesPartsPDFisLoading} unmountOnExit style={{position: 'absolute', top: '25%', right: '2%', zIndex: '100', width: '20px', height: '20px'}}>  
                                    <CircularProgress />
                                  </Fade>
                                </div>
                            </Button>
                        </li>
                        <li className="asideNavItemHolder">
                            <Button
                                disabled={!hasSelectedActivitiesFiles || activitiesFilesIsLoading}
                                fullWidth
                                startIcon={<MyIcons icon='getAppIcon'/>}
                                className="asideNavItem"
                                id="activitiesExportFilesBtn"
                                onClick={exportActivitiesFiles}
                            >
                                {translation.sideMenuExportActivitiesFilesLabel}
                                <div className="loaderHolder">
                                  <Fade in={activitiesFilesIsLoading} unmountOnExit style={{position: 'absolute', top: '25%', right: '2%', zIndex: '100', width: '20px', height: '20px'}}>
                                    <CircularProgress />
                                  </Fade>
                                </div>
                            </Button>
                        </li>
                        {activities && activities.filter(a => a.selected).length > 0 && (
                            <li className="asideNavItemHolder">
                            <Button
                                fullWidth
                                startIcon={<MyIcons icon='progressIcon'/>}
                                className="asideNavItem"
                                id="activitiesMarkInProgressBtn"
                                onClick={() => EventEmitter.emit('openMarkInProgressModal')}
                            >
                                {translation.sideMenuMarkAsInProgressLabel}
                            </Button>
                        </li>
                        )}
                    </ul>
                }
                {location.pathname === '/reports' && <ul className="asideNav">
                    <li className="asideNavItemHolder">
                        <Button
                            fullWidth
                            startIcon={<MyIcons icon='equalizerIcon'/>}
                            className="asideNavItem"
                            onClick={(e) => setIsOpenSaveScheduleModal(true)}
                            id="reportsAddScheduledReportBtn"
                        >
                            {translation.sideMenuScheduledReportsLabel}
                        </Button>
                    </li>
                    <li className="asideNavItemHolder">
                        <Button
                            disabled={!selectedReportsIds.length}
                            fullWidth
                            startIcon={<MyIcons icon='deleteOutlineIcon'/>}
                            className="asideNavItem"
                            id="reportsRemoveBtn"
                            onClick={(e) => setIsOpenDeleteReportsModal(true)}
                        >
                            {translation.sideMenuRemoveLabel}
                        </Button>
                    </li>
                </ul>}
                {location.pathname === '/asset-types'  && <ul className="asideNav">
                    {isSuperUser && <li className="asideNavItemHolder">
                        <Button
                            fullWidth
                            startIcon={<MyIcons icon='addCircleOutlineIcon'/>}
                            className="asideNavItem"
                            id="assetTypesAddBtn"
                            onClick={(e) => setIsOpenCreateEditAssetTypeModal(true)}
                        >
                            Add Asset Type
                        </Button>
                    </li>}
                </ul>}
                {location.pathname === '/asset-metrics'  && <ul className="asideNav">
                    {isSuperUser && <li className="asideNavItemHolder">
                        <Button
                            fullWidth
                            startIcon={<MyIcons icon='addCircleOutlineIcon'/>}
                            className="asideNavItem"
                            id="metricsAddBtn"
                            onClick={(e) => setIsOpenCreateEditMetricModal(true)}
                        >
                            Add Metric
                        </Button>
                    </li>}
                </ul>}
                
                {/* {location.pathname === '/notifications' && <ul className="asideNav">
                    <li className="asideNavItemHolder">
                        <Button
                            fullWidth
                            startIcon={<MyIcons icon='equalizerIcon'/>}
                            className="asideNavItem"
                            onClick={() => EventEmitter.emit('CreateNotification')}
                            id="notificationsAddNotificationsBtn"
                        >
                            {translation.sideMenuCreateNotificationLabel}
                        </Button>
                    </li>
                    <li className="asideNavItemHolder">
                        <Button
                            disabled={!allowRemoveNotifications}
                            fullWidth
                            startIcon={<MyIcons icon='deleteOutlineIcon'/>}
                            className="asideNavItem"
                            id="notificationsRemoveNotificationsBtn"
                            onClick={() => EventEmitter.emit('RemoveBatchNotifications')}
                        >
                            {translation.sideMenuRemoveLabel}
                        </Button>
                    </li>
                </ul>} */}
                {location.pathname === '/departments' && <ul className="asideNav">
                <li className="asideNavItemHolder">
                        <Button
                            fullWidth
                            id='departmentsAddBtn'
                            startIcon={<MyIcons icon='addCircleOutlineIcon'/>}
                            className="asideNavItem"
                            onClick={(e) => setIsOpenSaveDepartmentModal(true)}
                        >
                            {translation.sideMenuAddNewDepartmentLabel}
                        </Button>
                        <input type="file" id="file"
                                   ref={inputFile} style={{ display: 'none' }}
                                   onChange={(e) => {
                                       if (!e.target.files[0])
                                           return;
                                       onFileSelected(e.target.files[0]);
                                   }} />
                    </li>
                </ul>}
                {location.pathname === '/employees' && <ul className="asideNav">
                    <li className="asideNavItemHolder">
                        <Button
                            disabled={!departments}
                            fullWidth
                            startIcon={<MyIcons icon='personAddIcon'/>}
                            className="asideNavItem"
                            onClick={(e) => setIsOpenSaveEmployeeModal(true)}
                            id="employeesAddBtn"
                        >
                            {translation.sideMenuAddNewEmployeeLabel}
                        </Button>
                    </li>
                </ul>}
                {location.pathname === '/unassigned-components' && <ul className="asideNav">
                    <li className="asideNavItemHolder">
                        <Button
                            fullWidth
                            startIcon={<MyIcons icon='addCircleOutlineIcon'/>}
                            className="asideNavItem"
                            onClick={(e) => EventEmitter.emit('CreateUnassignedComponent')}
                            id="ucAddComponentBtn"
                        >
                            {translation.saveComponentModalAddChildComponentLabel}
                        </Button>
                    </li>
                    <li className="asideNavItemHolder">
                        <Button
                            disabled={!selectedUCIds?.length}
                            fullWidth
                            startIcon={<MyIcons icon='deleteOutlineIcon'/>}
                            className="asideNavItem"
                            id="ucRemoveComponentBtn"
                            onClick={(e) => setIsOpenDeleteUCModal(true)}
                        >
                            {translation.sideMenuRemoveLabel}
                        </Button>
                    </li>
                </ul>}
            </div>
        );
    };


    const openAsidePopover = Boolean(anchorElAsidePopover);
    const contextMenu = renderContextMenu();

    return (
        <div className="predMainLayout">
            <CssBaseline />
            {!dashboardId && <Header />}
            {isLoading ? (
          <div className="loaderHolder">
            <Fade in={isLoading} unmountOnExit style={{position: 'absolute', top: '20%', left: '50%', zIndex: '100'}}>  
              <CircularProgress />
            </Fade>
          </div>
        ) : null}
            <main className="main" style={!!contextMenu ? undefined : {paddingRight: 0}}>
                {!location.pathname.startsWith('/asset-types/') && (
                    <div className="pmSubHeader">
                        <div className="title">{pageTitle}</div>
                        {contextMenu && (
                            <div className="subMenuDrawerHolder">
                                <IconButton
                                    disabled={!isSuperUser && location.pathname === '/catalog' &&
                                        ((currentPage === 'parts' && selectedPartsCatalogIds.length === 0) ||
                                            (currentPage === 'components' && selectedComponentsCatalogIds.length === 0))}
                                    onClick={handleClickAsidePopover}>
                                    <MenuIcon />
                                </IconButton>
                                <Popover
                                    open={openAsidePopover}
                                    anchorEl={anchorElAsidePopover}
                                    onClose={handleCloseAsidePopover}
                                    disableScrollLock={true}
                                    anchorOrigin={{
                                        vertical: 'bottom',
                                        horizontal: 'right',
                                    }}
                                    transformOrigin={{
                                        vertical: 'top',
                                        horizontal: 'right',
                                    }}
                                >
                                    {contextMenu}
                                </Popover>
                            </div>
                        )}
                    </div>
                )}
                {children}
            </main>
            <aside className="mainAside">
                <input
                    type="file"
                    accept="image/*"
                    ref={inputCompanyLogoRef}
                    style={{ display: 'none' }}
                    onChange={(e) => {
                        if (!e.target.files?.[0]) return;
                        onFileSelected(e.target.files[0]);
                        e.target.value = '';
                    }}
                />
                <div className="subNavHolder" style={{padding: '10px', marginTop: '5px'
                }}>
                <div
                        className={` asideNavItemCompany ${['/companies'].includes(location.pathname) ? 'active' : ''}`}
                        // onClick={(e) => history.push('/companies')}
                        id='asideMmsMenuMyCompanyBtn'
                    >
                        <span className="asideNavCompanyLogo">
                            {editingCompany?.image
                                ? <img src={`data:image/jpeg;base64,${editingCompany.image}`} alt="" />
                                : <MyIcons icon="companyIcon" style={{ width: 96, height: 48, fill: 'rgb(0 0 0 / 16%)' }} />
                            }
                        </span>
                        <div className="asideNavCompanyNameHolder">
                            <div className="asideNavCompanyNameHolderContent">
                            {(() => {
                                const companyName = currentCompany?.name || translation.siderMyCompanyLabel;
                                const displayCompanyName = companyName?.length > 25 ? `${companyName.slice(0, 25)}...` : (companyName ?? '');
                                const fullName = companyName ?? '';
                                return (
                                    <Tooltip title={fullName} placement="top" enterDelay={300} leaveDelay={0}>
                                        <span className="asideNavCompanyName">{displayCompanyName}</span>
                                    </Tooltip>
                                );
                            })()}
                            {editingCompany?.timezone != null && editingCompany?.timezone !== '' && (() => {
                                const timezoneText = `${translation.timezoneLabel}: ${editingCompany.timezone}`;
                                const displayTimezone = timezoneText.length > 30 ? `${timezoneText.slice(0, 30)}...` : timezoneText;
                                return (
                                    <Tooltip title={timezoneText} placement="top" enterDelay={300} leaveDelay={0}>
                                        <span className="asideNavCompanyTimezone">{displayTimezone}</span>
                                    </Tooltip>
                                );
                            })()}
                            </div>
                            <IconButton size="small" className="asideNavCompanyArrow" onClick={handleCompanyMenuOpen} aria-label="Menu">
                                <MyIcons icon="settingsIcon" style={{ width: '16px', height: '16px' }} />
                            </IconButton>
                        </div>
                    </div>
                    <Popover
                        open={Boolean(anchorCompanyMenuEl)}
                        anchorEl={anchorCompanyMenuEl}
                        onClose={handleCompanyMenuClose}
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                    >
                        <MenuItem
                            onClick={() => {
                                handleCompanyMenuClose();
                                setIsOpenSaveCompanyModal(true);
                            }}
                            id="asideCompanyEditBtn"
                        >
                            <MyIcons icon="createIcon" className="asideNavPopoverIcon" style={{width: '16px', height: '16px', marginRight: '8px'}} />
                            {translation.sideMenuEditCompanyLabel}
                        </MenuItem>
                        <MenuItem
                            onClick={() => {
                                handleCompanyMenuClose();
                                inputCompanyLogoRef.current?.click();
                            }}
                            id="asideCompanyChangeLogoBtn"
                        >
                            <MyIcons icon="photoCamera" className="asideNavPopoverIcon" style={{width: '16px', height: '16px', marginRight: '8px'}} />
                            {translation.sideMenuEditLogoLabel}
                        </MenuItem>
                    </Popover>

                </div>
                <div className="subNavHolder">


                    <div>
                        <Button
                            fullWidth
                            startIcon={<MyIcons icon='domainIcon'/>}
                            className={`asideNavItem ${['/departments'].includes(location.pathname) ? 'active' : ''}`}
                            onClick={(e) => history.push(`/departments`)}
                            id='asideMmsMenuDepartmentsBtn'
                            >{translation.myCompanyDepartmentsLabel}</Button>

                        <Button
                            fullWidth
                            startIcon={<MyIcons icon='peopleAltIcon'/>}
                            className={`asideNavItem ${['/employees'].includes(location.pathname) ? 'active' : ''}`}
                            onClick={(e) => history.push(`/employees`)}
                            id='asideMmsMenuEmployeesBtn'
                            >{translation.myCompanyEmployeesLabel}</Button>
                        <Button
                            fullWidth
                            startIcon={<MyIcons icon='settingsIcon'/>}
                            className={`asideNavItem ${['/parts'].includes(location.pathname) ? 'active' : ''}`}
                            onClick={(e) => history.push(`/parts`)}
                            id="asideMmsMenuPartsBtn"
                            >{translation.equipmentPagePartsLabel}</Button>
                        <Button
                            disabled={!currentDepartment}
                            fullWidth
                            startIcon={<MyIcons icon='componentsIcon'/>}
                            className={`asideNavItem ${location.pathname === '/unassigned-components' ? 'active' : ''}`}
                            onClick={(e) => history.push(`/unassigned-components`)}
                            id="asideMmsMenuUCBtn"
                        >
                            {translation.siderUnassignedComponentsLabel}
                        </Button>
                    </div>


                {/* <Switch>
                    <PrivateRoute path={`${path}`} component={DepartmentsComponent} exact/>
                    <PrivateRoute path={`${path}/employees`}  component={EmployeesComponent}/>
                </Switch> */}


                </div>
                <div className="asideNavHolder">
                    <ul className="asideNav">
                        {/*<li className="asideNavItemHolder">*/}
                        {/*    <Button*/}
                        {/*        disabled={!currentDepartment}*/}
                        {/*        fullWidth*/}
                        {/*        startIcon={<BarChartSharp />}*/}
                        {/*        className={`asideNavItem ${['/dashboard'].includes(location.pathname) ? 'active' : ''}`}*/}
                        {/*        onClick={(e) => history.push(`/dashboard`)}*/}
                        {/*    >*/}
                        {/*        {translation.siderDashboardLabel}*/}
                        {/*    </Button>*/}
                        {/*</li>*/}
                        <li className="asideNavItemHolder">
                            <Button
                                id="asideMmsMenuChangeDepartmentBtn"
                                onClick={(e) => {
                                    if (!departments || departments.length === 0) return;
                                    setDepartmentSearchQuery('');
                                    setDepartmentSelectAnchor(e.currentTarget);
                                }}
                                disabled={!departments || departments.length === 0}
                                className="asideNavItem"
                                fullWidth
                                startIcon={<MyIcons icon="accountTreeIcon" />}
                                endIcon={<ArrowDropDownIcon className="asideDepartmentMenuChevron" />}
                            >
                                <span className="hasMaxWidth">
                                    {currentDepartment?.name || 'Select Department'}
                                </span>
                            </Button>
                            <Popover
                                open={Boolean(departmentSelectAnchor)}
                                anchorEl={departmentSelectAnchor}
                                onClose={() => {
                                    setDepartmentSelectAnchor(null);
                                    setDepartmentSearchQuery('');
                                }}
                                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                                transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                                marginThreshold={8}
                                PaperProps={{
                                    className: 'asideDepartmentSelectPopoverPaper',
                                    style: {
                                        width: 224,
                                        maxWidth: 'min(-24px + 100vw, 400px)',
                                    },
                                }}
                            >
                                <div className="asideDepartmentSelectPopoverInner">
                                    <div className="asideDepartmentSelectSearchRow">
                                        <TextField
                                            size="small"
                                            variant="outlined"
                                            placeholder="Search"
                                            value={departmentSearchQuery}
                                            onChange={(e) => setDepartmentSearchQuery(e.target.value)}
                                            fullWidth
                                            autoFocus
                                            margin="dense"
                                            className="asideDepartmentSelectSearch"
                                            onKeyDown={(e) => e.stopPropagation()}
                                            inputProps={{ 'aria-label': 'Search departments' }}
                                        />
                                    </div>
                                    <List
                                        dense
                                        component="nav"
                                        className="asideDepartmentSelectList"
                                        disablePadding
                                    >
                                        {(filteredDepartments || []).length === 0 ? (
                                            <ListItem disabled>
                                                <ListItemText primary="No matching departments" />
                                            </ListItem>
                                        ) : (
                                            (filteredDepartments || []).map((option) => (
                                                <ListItem
                                                    button
                                                    key={option.id}
                                                    selected={currentDepartment?.id === option.id}
                                                    id={`asideMmsMenuChooseDepartmentBtn-${option.id}`}
                                                    onClick={() => {
                                                        setCurrentDepartment(option);
                                                        setStoredDepartment(option.id);
                                                        setDepartmentSelectAnchor(null);
                                                        setDepartmentSearchQuery('');
                                                    }}
                                                >
                                                    <ListItemText primary={option.name} />
                                                </ListItem>
                                            ))
                                        )}
                                    </List>
                                </div>
                            </Popover>
                        </li>

                        <div className='mainAsideSubItems'>
                            <li className="asideNavItemHolder">
                                <Button
                                    disabled={!currentDepartment}
                                    fullWidth
                                    startIcon={<MyIcons icon='buildIcon' style={{width: '17px', height: '17px'}}/>}
                                    className={`asideNavItem ${['/equipment', '/equipment/parts'].includes(location.pathname) ? 'active' : ''}`}
                                    onClick={(e) => history.push(`/equipment`)}
                                    id="asideMmsMenuAssetsBtn"
                                >
                                    {translation.siderEquipmentLabel}
                                </Button>
                            </li>
                            {/* {isSuperUser && <li className="asideNavItemHolder">
                                <Button
                                    disabled={!currentDepartment}
                                    fullWidth
                                    startIcon={<MyIcons icon='developerBoardIcon'/>}
                                    className={`asideNavItem ${location.pathname === '/catalog' ? 'active' : ''}`}
                                    onClick={(e) => history.push(`/catalog`)}
                                    id="asideMmsMenuTemplatesBtn"
                                >
                                    {translation.siderCatalogLabel}
                                </Button>
                            </li>} */}
                            
                            <li className="asideNavItemHolder">
                                <Button
                                    disabled={!currentDepartment}
                                    fullWidth
                                    startIcon={<MyIcons icon='playlistAddCheckIcon'/>}
                                    className={`asideNavItem ${location.pathname === '/activities' ? 'active' : ''}`}
                                    onClick={(e) => history.push(`/activities`)}
                                    id="asideMmsMenuActivitiesBtn"
                                >
                                    {translation.siderActivitiesLabel}
                                </Button>
                            </li>
                            <li className="asideNavItemHolder">
                                <Button
                                    disabled={!currentDepartment}
                                    fullWidth
                                    startIcon={<MyIcons icon='assessmentIcon'/>}
                                    className={`asideNavItem ${location.pathname === '/reports' ? 'active' : ''}`}
                                    onClick={(e) => history.push(`/reports`)}
                                    id="asideMmsMenuReportsBtn"
                                >
                                    {translation.scheduledReportsTabLabel}
                                </Button>
                            </li>
                            {/* <li className="asideNavItemHolder">
                                <Button
                                    disabled={!currentDepartment}
                                    fullWidth
                                    startIcon={<MyIcons icon='notificationImportant'/>}
                                    className={`asideNavItem ${location.pathname === '/notifications' ? 'active' : ''}`}
                                    onClick={(e) => history.push(`/notifications`)}
                                    id="asideMmsMenuNotificationsBtn"
                                >
                                    {translation.notificationsPageLabel}
                                </Button>
                            </li> */}
                        </div>
                    </ul>
                </div>
                
                {isSuperUser && (
                    <div className="subNavHolder">
                    <Button
                        fullWidth
                        startIcon={<MyIcons icon='settingIcon'/>}
                        className={`asideNavItem `}
                    >
                        Settings
                    </Button>
                    <div className='mainAsideSubItems'>
                    <div className="asideNavItemHolder">
                                <Button
                                    fullWidth
                                    startIcon={<MyIcons icon='developerBoardIcon' style={{width: '17px', height: '17px'}}/>}
                                    className={`asideNavItem ${location.pathname === '/asset-types' ? 'active' : ''}`}
                                    onClick={(e) => history.push(`/asset-types`)}
                                    id="asideMmsMenuAssetTypesBtn"
                                >
                                    Asset Types
                                </Button>
                            </div>
                        <Button
                            fullWidth
                            startIcon={<MyIcons icon='graphicEqIcon'/>}
                            className={`asideNavItem ${['/asset-metrics'].includes(location.pathname) ? 'active' : ''}`}
                            onClick={(e) => history.push(`/asset-metrics`)}
                            id='asideMmsMenuMetricsBtn'
                            >Metrics
                            </Button>
                        </div>
                </div>
                )}
            </aside>
            {contextMenu && (
                <aside className="secondaryAside">
                    {contextMenu}
                </aside>
            )}
            <footer className="mainFooter">
                <div className="mainContainer">
                    <div className="footerWrapper">
                        <ThemeSelector />
                        <LanguageSelector />
                        <div className="copyright">
                            {appName}
                        </div>
                    </div>
                </div>
            </footer>
            <SaveCompanyModal
                open={isOpenSaveCompanyModal}
                handleClose={(e) => setIsOpenSaveCompanyModal(false)} />
            <SaveDepartmentModal
                open={isOpenSaveDepartmentModal}
                handleClose={(e) => setIsOpenSaveDepartmentModal(false)}
                onSuccessSave= {() => queryClient.invalidateQueries(['departments'])}
            />
            <SaveEmployeeModal
                open={isOpenSaveEmployeeModal}
                handleClose={(e) => setIsOpenSaveEmployeeModal(false)} />
            <SaveComponentModal
                open={isOpenSaveComponentModal}
                handleClose={(e) => setIsOpenSaveComponentModal(false)}
                isCatalog={isCatalog}
                onSuccessSave={item => {}}
            />
            <SavePartModal
                open={isOpenSavePartModal}
                handleClose={(e) => setIsOpenSavePartModal(false)}
                isCatalog={isCatalog} />
            <DeleteItemModal
                isOpen={isOpenDeleteComponentsModal}
                isOpenManager={setIsOpenDeleteComponentsModal}
                message={translation.removeComponentsModalMessageLabel}
                onDeleteModalClose={(e) => onDeleteComponents()} />
            <DeleteItemModal
                isOpen={isOpenDeletePartsModal}
                isOpenManager={setIsOpenDeletePartsModal}
                message={translation.removePartsModalMessageLabel}
                onDeleteModalClose={(e) => onDeleteParts()} />
            <DeleteItemModal
                isOpen={isOpenDeleteReportsModal}
                isOpenManager={setIsOpenDeleteReportsModal}
                message={translation.removeReportsModalMessageLabel}
                onDeleteModalClose={(e) => onDeleteReports()} />
            <DeleteItemModal
                isOpen={isOpenDeleteUCModal}
                isOpenManager={setIsOpenDeleteUCModal}
                message={translation.removeUCModalMessageLabel}
                onDeleteModalClose={(e) => onDeleteUnassignedComponents()} />    
            <ChangeDepartmentModal
                open={isOpenChangeDepartmentModal}
                handleClose={(e) => setIsOpenChangeDepartmentModal(false)}
                department={currentDepartment}
                componentIds={selectedComponentsIds} />
            {/* <DuplicateComponentModal
                isOpen={isOpenDuplicateComponentModal}
                isOpenManager={setIsOpenDuplicateComponentModal}
                componentIds={isCatalog ? selectedComponentsCatalogIds : selectedComponentsIds}
                departmentId={currentDepartment?.id}
                isCatalog={isCatalog}
            /> */}
            <CloneToEquipmentModal
                isOpen={isOpenCloneToEquipmentModal}
                isOpenManager={setIsOpenCloneToEquipmentModal}
                ids={cloneInstance === 'components' ? selectedComponentsCatalogIds : selectedPartsCatalogIds}
                departmentId={currentDepartment?.id}
                instance={cloneInstance} />
            <SaveScheduledReportsModal
                isOpen={isOpenSaveScheduleModal}
                isOpenManager={setIsOpenSaveScheduleModal} />
            <ExportReportModal
                open={isOpenExportReportModal}
                handleClose={() => setIsOpenExportReportModal(false)}
                onExport={exportReport}
            />
            <ExportConfirmationModal
                open={isExportConfirmationOpen}
                onClose={() => setIsExportConfirmationOpen(false)}
                onConfirm={handleConfirmExport}
                onShowFilter={handleShowFilter}
                activitiesCount={
                    activities.filter(a => a.selected).length > 20
                      ? activities.filter(a => a.selected).length
                      : activities.length
                }
            />
            <CreateEditAssetTypeModal
                isOpen={isOpenCreateEditAssetTypeModal}
                isOpenChangeHandler={setIsOpenCreateEditAssetTypeModal}
                onSuccess={() => {
                    window.dispatchEvent(new CustomEvent('refreshAssetTypes'));
                }}
            />
            <AddEditMetricModal
                isOpen={isOpenCreateEditMetricModal}
                isOpenChangeHandler={setIsOpenCreateEditMetricModal}
                onSuccess={() => {
                    window.dispatchEvent(new CustomEvent('refreshMetrics'));
                }}
            />
        </div>
    );
};

const mapDispatchToProps = {
    setCurrentDepartment,
    setDepartments,
    setComponents,
    setParts,
    setRunComponentsUpdate,
    setUnassignedComponents,
    setStatusOptions,
    setStates,
    setTypeOptions,
    setEmployees,
    setReports,
    setEditingCompany
};

const mapStateToProps = ({ mms, dashboard }) => ({
    departments: mms.departments,
    editingCompany: mms.editingCompany,
    currentDepartment: mms.currentDepartment,
    currentCompany: dashboard.currentCompany,
    currentPage: mms.currentPage,
    components: mms.components,
    parts: mms.parts,
    componentsCatalog: mms.componentsCatalog,
    partsCatalog: mms.partsCatalog,
    reports: mms.reports,
    filterInfo: mms.filterInfo,
    activities: mms.activities,
    pageTitle: mms.pageTitle,
    rspSelectedComponentsIds: mms.rspSelectedComponentsIds,
    selectedUnassignedComponentsIds: mms.selectedUnassignedComponentsIds,
});

export default connect(mapStateToProps, mapDispatchToProps)(PredMainLayout);

